import { Component } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ICellRendererAngularComp } from '@ag-grid-community/angular';
import { ICellRendererParams } from '@ag-grid-community/core';
import { IconSvgComponent } from '../../icon/icon.component';

@Component({
  selector: 'rx-applications-boolean-icon-cell',
  standalone: true,
  imports: [CommonModule, IconSvgComponent],
  templateUrl: './boolean-icon-cell.component.html',
  styleUrls: ['./boolean-icon-cell.component.scss'],
})
export class BooleanIconCellComponent implements ICellRendererAngularComp {
  isActive: boolean | null;
  testId: string;

  agInit(params: ICellRendererParams): void {
    this.isActive = params.value;
    this.testId = params?.colDef?.cellRendererParams?.testId || 'test-boolean-icon-cell';
  }

  refresh(): boolean {
    return false;
  }
}
